import { memo } from 'react';

import Description from '@picsart/growth-rc/Description';
import { useTranslator } from '@picsart/rc/services/localization';

import { Image } from '@picsart/design-system/components/Image';
import useStyles from './styles';
import { CardsSectionItemProps } from './types';

const CardsSectionItem = ({ image, title, description }: CardsSectionItemProps) => {
  const classes = useStyles();
  const translate = useTranslator();

  return (
    <div className={classes.root}>
      <div className={classes.imageWrapper}>
        <Image
          src={image.src}
          alt={image?.alt}
          data-testid="cards-section-item-image"
          width={image.width ? image.width : 360}
          height={image.height ? image.height : 225}
        />
      </div>
      <div className={classes.content}>
        <p className={classes.title} data-testid="cards-section-item-title">
          {translate(title)}
        </p>
        {description && <Description {...description} text={translate(description.text)} />}
      </div>
    </div>
  );
};

export default memo(CardsSectionItem);
